
// import Animation from '@/components/animation'
import imgSrc1 from '~/assets/img/home/product_mb_new_01.svg'
import imgSrc2 from '~/assets/img/home/product_mb_new_02.svg'
import imgSrc3 from '~/assets/img/home/product_mb_new_03.png'
import { requireImgAssets } from '@/utils/utils'

// CMS 组装取图配置：Menu/Main 两个接口都不返回图片，
// 右侧小图 img/imgAlt 与左侧大图 img_mb 按 Tab 的 productType 固定映射，与各站点 data.js 无关
const BG_NEW_01 = requireImgAssets('@/assets/img/home/product_bg_new_01.svg')
const BG_NEW_02 = requireImgAssets('@/assets/img/home/product_bg_new_02.svg')
const BG_NEW_03 = requireImgAssets('@/assets/img/home/product_bg_new_03.png')
const BG_NEW_04 = requireImgAssets('@/assets/img/home/product_bg_new_04.png')
const MB_NEW_02 = requireImgAssets('@/assets/img/home/product_mb_new_02.svg')
const MB_NEW_03 = requireImgAssets('@/assets/img/home/product_mb_new_03.png')
const MB_NEW_04 = requireImgAssets('@/assets/img/home/product_mb_new_04.png')
const IMG_MB_CN_KR = requireImgAssets('@/assets/img/home/product_mb_cn_kr.svg')
const IMG_MB_SEA = requireImgAssets(
  '@/assets/img/home/product_mb_vn_th_my_sg_ph.svg'
)
const IMG_MB_WEST = requireImgAssets(
  '@/assets/img/home/product_mb_us_eu_au_fr_de.svg'
)
// 站点 → 左侧大图分组（type 1 与兜底类型按站点取用）
const IMG_MB_BY_SITE = {
  cn: IMG_MB_CN_KR,
  vn: IMG_MB_SEA,
  th: IMG_MB_SEA,
  my: IMG_MB_SEA,
  sg: IMG_MB_SEA,
  ph: IMG_MB_SEA,
  us: IMG_MB_WEST,
  eu: IMG_MB_WEST,
  au: IMG_MB_WEST,
  fr: IMG_MB_WEST,
  de: IMG_MB_WEST,
}
// productType → { 右侧小图 img, 左侧大图 img_mb }；img_mb 统一用 function(site) 表达便于按站点解析
const PRODUCT_TYPE_IMAGES = {
  1: { img: BG_NEW_01, img_mb: (site) => IMG_MB_BY_SITE[site] || IMG_MB_WEST },
  2: { img: BG_NEW_02, img_mb: () => MB_NEW_02 },
  4: { img: BG_NEW_03, img_mb: () => MB_NEW_03 },
  5: { img: BG_NEW_04, img_mb: () => MB_NEW_04 },
}
// Menu 返回映射表外的新 productType 时兜底：右图固定 01，大图 cn 站点用 cn 分组、其余用西方分组
const PRODUCT_TYPE_IMG_FALLBACK = {
  img: BG_NEW_01,
  img_mb: (site) => (site === 'cn' ? IMG_MB_CN_KR : IMG_MB_WEST),
}

// 首页产品区走 CMS 配置：
//   Tab 个数/顺序/标题 = getLogisticsServiceMenu 的 result.product.children
//     （layouts/base.vue 已统一拉取并缓存在 Vuex state.productMenus，本组件不重复发请求）
//   Tab 内产品列表     = getLogisticsServiceMain({type:1})，按 tab 上 CMS 配置的 productType 匹配
// 兜底只有一种情况：接口失败/超时，回落 data.js 静态内容；
// 接口正常返回（包括内容为空、未配 productType）一律按 CMS 组装，空就是该站点没产品，不兜底
export default {
  components: {
    // Animation,
  },
  props: {
    clientData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      imgSrc1,
      imgSrc2,
      imgSrc3,
      current: {
        0: 0,
        1: 0,
      },
      product_wrap_imgUrl: '',
      // product_wrap_imgUrl: '~/assets/img/home/product_mb_new_01.svg',
      // product_wrap_imgUrl: '/product_mb_new_01.svg',
      product_wrap_imgUrlList: [],
      activeTabs: 0,
      sonContent: [],
      openTimer: null,
      // 首页产品区走 CMS 配置：与各站点 data.js 的 children 平行的展示模型
      // 初始为静态内容副本（供 SSR 和接口失败/超时兜底），CMS 组装成功后整块替换
      mergedChildren: [],
      // Main 接口返回的产品列表（null=还没回来）
      mainList: null,
      // 已组装标志：组装只做一次
      cmsApplied: false,
      // 接口等待期骨架屏：组装成功/接口失败/超时都会置 false
      showSkeleton: true,
      // 接口一直 pending（如网络挂起）时的安全阀定时器
      skeletonTimer: null,
    }
  },
  computed: {
    lang() {
      return this.$route.params.lang
    },
  },
  watch: {
    // base.vue 拉完 Menu 会 commit 进 store，可能晚于本组件 mounted；
    // Menu 到了就试着组装（Main 没到就等着，Main 的 then 里也会试着组装）
    '$store.state.productMenus'() {
      this.tryMerge()
    },
  },
  created() {
    // 先原样复制静态结构，SSR/接口失败时首页照常渲染 data.js 内容
    this.mergedChildren = (this.clientData || []).map((group) =>
      (group.children || []).map((tab) => ({
        ...tab,
        children: [...(tab.children || [])],
      }))
    )
  },
  mounted() {
    console.log('clientData---', this.clientData)
    // 安全阀：接口等待期最长 5 秒，超时回落静态兜底，不能一直停在骨架屏
    // （axios 无全局 timeout 配置，请求可能长时间 pending）
    this.skeletonTimer = setTimeout(() => {
      this.showSkeleton = false
    }, 5000)
    this.product_wrap_imgUrlList = this.clientData[0].children.map((item) => {
      return item.img_mb
    })
    // this.product_wrap_imgUrlList = [
    //   '~/assets/img/home/product_mb_new_01.svg',
    //   '~/assets/img/home/product_bg_02.png',
    //   '~/assets/img/home/product_mb_new_03.png'
    // ]
    this.clickTab(this.clientData[0].children[0], 0)
    console.log('product_wrap_imgUrlList---', this.product_wrap_imgUrlList)
    this.fetchMain()
    this.tryMerge()
  },
  beforeDestroy() {
    if (this.openTimer) {
      clearTimeout(this.openTimer)
      this.openTimer = null
    }
    if (this.skeletonTimer) {
      clearTimeout(this.skeletonTimer)
      this.skeletonTimer = null
    }
  },
  methods: {
    // 仅展示"有产品"的 Tab：接口返回后某类无产品则整个 Tab 隐藏
    visibleChildren(gIndex) {
      const tabs = (this.mergedChildren[gIndex] || {}).children || []
      return tabs.filter((tab) => (tab.children || []).length > 0)
    },
    // 发 Main 请求（产品详情，参数固定 {type:1}），结果存 mainList。
    // 仅接口失败/超时才回落静态兜底；正常返回（包括空数组）都走组装
    fetchMain() {
      this.$API.product
        .getLogisticsServiceMain({ type: 1 })
        .then((res) => {
          this.mainList = res?.result || []
          this.tryMerge()
        })
        .catch((e) => {
          console.log('home product config fetch error---', e)
          // 接口失败：关骨架，渲染 data.js 静态兜底
          this.showSkeleton = false
        })
    },
    // 组装：Menu（store）和 Main（mainList）都到了才合并，合并一次就置标志
    tryMerge() {
      if (this.cmsApplied) return
      if (!this.$store.state.productMenusLoaded) return // Menu 没回来，等着
      if (this.mainList === null) return // Main 没回来，等着
      const menuProduct = (this.$store.state.productMenus || []).find(
        (m) => m.name === 'product'
      )
      // 两个接口都正常返回了就组装，CMS 配成啥样渲染啥样（空=该站点没产品，不兜底）
      this.applyProductConfig(menuProduct?.children || [], this.mainList)
    },
    applyProductConfig(menuTabs, list) {
      // Tab：个数/顺序/标题完全以 Menu 接口 product.children 为准（配置啥是啥）
      // 图片不走 CMS 也不走 data.js：右图/大图按 productType 查 PRODUCT_TYPE_IMAGES 固定映射
      const site = this.$route.params.site
      const tabs = menuTabs
        .map((mt) => {
          // Menu 的 tab 对象上有 CMS 配置的 productType，用它关联 Main 接口的产品
          const productType = Number(mt.productType) || null
          // 映射表外的类型统一兜底图，防 Menu 返回新 productType 时右图空白
          const imgs =
            PRODUCT_TYPE_IMAGES[productType] || PRODUCT_TYPE_IMG_FALLBACK
          return {
            productType,
            title: mt.cname || mt.name,
            children: [],
            img: imgs.img,
            imgAlt: imgs.imgAlt || '',
            img_mb: imgs.img_mb(site),
          }
        })
        // 没配 productType 的 Tab 匹配不到任何产品，不并入 CMS 结构（即不展示）
        .filter((t) => t.productType)
      list.forEach((it) => {
        const tab = tabs.find((t) => t.productType === Number(it.productType))
        if (!tab) return
        const hasSort =
          it.sort !== '' &&
          it.sort !== null &&
          it.sort !== undefined &&
          !isNaN(Number(it.sort))
        const path = this.toInternalPath(it.url)
        tab.children.push({
          raw: true,
          title: it.name,
          subTitle: it.productDescription || '',
          path,
          params: {},
          // 接口给的是含站内前缀的绝对链接，转成站内路径后整路径使用
          rootReplace: path !== '#',
          _sort: hasSort ? Number(it.sort) : null,
        })
      })
      // sort 有值的在前按升序；为空的保持接口返回顺序垫后
      tabs.forEach((tab) => {
        tab.raw = true
        const withSort = tab.children
          .filter((c) => c._sort !== null)
          .sort((a, b) => a._sort - b._sort)
        const rest = tab.children.filter((c) => c._sort === null)
        tab.children = withSort.concat(rest)
      })
      // 组对象只装 CMS 组装的 Tab 列表；区块标题在模板写死，不在这里管
      this.mergedChildren = [{ children: tabs }]
      this.cmsApplied = true
      this.showSkeleton = false
      // 打印最终组装结果（深拷贝去掉 Vue 响应式包装），供核对 DOM 是否有丢内容
      console.log(
        'home product assembled data---',
        JSON.parse(JSON.stringify(this.mergedChildren))
      )
      this.$nextTick(() => {
        const visible = this.visibleChildren(0)
        this.product_wrap_imgUrlList = visible.map((tab) => tab.img_mb)
        this.activeTabs = 0
        if (visible[0]) {
          this.clickTab(visible[0], 0)
        } else {
          // CMS 组装出来没有任何可展示 Tab：清空内容区，不能留着静态内容当兜底
          this.sonContent = []
        }
      })
    }, // 把 CMS 的绝对链接转成站内路径（同系统），非法链接返回 '#'
    toInternalPath(url) {
      const reg = /(http(s)?:\/\/)?[a-z0-9A-Z]+\.(com|cn|net)(.+)?/
      if (!reg.test(url)) return '#'
      try {
        if (/^https?:\/\//.test(url)) {
          const parsed = new URL(url)
          const path = `${parsed.pathname}${parsed.search}${parsed.hash}`
          return path.startsWith('/') ? path : '#'
        }
        return url
      } catch (e) {
        console.log('toInternalPath error---', url, e)
        return '#'
      }
    },
    change(index, idx) {
      if (this.current[index] !== idx) {
        this.current[index] = idx
      }
    },
    clickTab(row, index) {
      console.log('sonContent', row)
      const children = row.children.filter((item) => {
        // raw=CMS 接口数据（无 subTitle 也要展示）；静态数据维持原逻辑按 subTitle 过滤掉"了解更多"占位
        return item.subTitle || item.raw
      })
      this.sonContent = { ...row, children }
      // this.product_wrap_imgUrl = this.product_wrap_imgUrlList[index]
      // if (index == 0) {
      //   this.product_wrap_imgUrl = imgSrc1
      // } else if (index == 1) {
      //   this.product_wrap_imgUrl = imgSrc2
      // } else if (index == 2) {
      //   this.product_wrap_imgUrl = imgSrc3
      // }
      console.log('product_wrap_imgUrl', this.product_wrap_imgUrl)

      const img = document.getElementById('main-image')
      // row.img_mb 没有发生变化就不执行动效
      if (
        img &&
        img.style?.opacity &&
        row.img_mb !== this.product_wrap_imgUrl
      ) {
        img.style.opacity = 0 // 开始淡出，设置透明度为0
      }
      if (this.openTimer) {
        clearTimeout(this.openTimer)
        this.openTimer = null
      }
      this.openTimer = setTimeout(() => {
        // img.src = this.product_wrap_imgUrlList[index]; // 更换图片源
        img.style.opacity = 1 // 图片源更换后，开始淡入，设置透明度为1
        this.product_wrap_imgUrl = this.product_wrap_imgUrlList[index]
      }, 500) // 延迟1秒后开始更换图片源，与CSS中的过渡时间相匹配

      // const leftImage = document.getElementById('left-image')
      // leftImage.style.left = '-40%' // 开始淡出，设置透明度为0
      // setTimeout(() => {
      //   // img.src = this.product_wrap_imgUrlList[index]; // 更换图片源
      //   leftImage.style.left = 0 // 图片源更换后，开始淡入，设置透明度为1
      //   this.product_wrap_imgUrl = this.product_wrap_imgUrlList[index]
      // }, 2000) // 延迟1秒后开始更换图片源，与CSS中的过渡时间相匹配
    },
    // setImg(){

    //   // return require('~/assets/img/home/product_mb_new_01.svg')
    //   console.log('this.product_wrap_imgUrl1111', '~/assets/img/home/product_mb_new_01.svg')
    //   console.log('this.product_wrap_imgUrl', this.product_wrap_imgUrl)
    //   // return require(this.product_wrap_imgUrl)
    //   return this.product_wrap_imgUrl
    // }
  },
}
